import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const DEPT_ICON = { sales: '💼', technical: '🔧', projects: '📋', other: '👤' };

export default function ContactPage() {
  const { lang, t, apiFetch } = useAuth();
  const [contacts, setContacts] = useState([]);
  const [distributor, setDistributor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/contacts').then(data => {
      if (data && Array.isArray(data.contacts)) {
        setContacts(data.contacts);
        if (data.distributor) setDistributor(data.distributor);
      } else if (Array.isArray(data)) {
        setContacts(data);
      } else {
        setContacts([]);
      }
    }).catch(() => setContacts([])).finally(() => setLoading(false));
  }, [apiFetch]);

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>{t('loading')}</div>;

  const byDept = contacts.reduce((acc, c) => {
    const dept = c.department || 'other';
    if (!acc[dept]) acc[dept] = [];
    acc[dept].push(c);
    return acc;
  }, {});

  const desc = distributor
    ? (distributor[`description_${lang}`] || distributor.description_cs)
    : 'Jsme autorizovaným distributorem Grandstream pro Českou republiku, Slovensko a Rumunsko.';

  return (
    <div>
      <h1 style={{ margin: '0 0 6px', fontSize: 26, fontWeight: 800, color: '#111827' }}>
        📞 {t('contactTitle')}
      </h1>
      <p style={{ margin: '0 0 32px', color: '#6b7280', fontSize: 15 }}>{t('contactSubtitle')}</p>

      {/* Distributor info */}
      <div style={{
        background: 'linear-gradient(135deg, #0e76bc 0%, #0b5e96 100%)',
        borderRadius: 14, padding: '28px 32px', marginBottom: 28, color: '#fff',
        display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20,
      }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>
            {distributor?.company_name || 'Grandstream Distributor'}
          </div>
          <div style={{ fontSize: 14, opacity: 0.85, lineHeight: 1.8 }}>
            {distributor?.address && <div>📍 {distributor.address}</div>}
            {distributor?.phone && <div>📞 {distributor.phone}</div>}
            {distributor?.email && <div>✉️ {distributor.email}</div>}
          </div>
        </div>
        <div>
          <div style={{ fontSize: 13, opacity: 0.8, marginBottom: 6, fontWeight: 600 }}>AUTORIZOVANÝ DISTRIBUTOR</div>
          <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: 8, padding: '10px 14px', fontSize: 13, opacity: 0.9, lineHeight: 1.7 }}>
            {desc}
          </div>
        </div>
      </div>

      {/* Contacts by department */}
      <div style={{ display: 'grid', gap: 20 }}>
        {Object.entries(byDept).map(([dept, people]) => {
          const deptLabel = t(`departments.${dept}`) || dept;
          const icon = DEPT_ICON[dept] || '👤';
          return (
            <div key={dept} style={{ background: '#fff', borderRadius: 12, padding: '20px 24px', boxShadow: '0 1px 6px rgba(0,0,0,0.06)', border: '1px solid #f3f4f6' }}>
              <h2 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700, color: '#374151', display: 'flex', alignItems: 'center', gap: 8 }}>
                {icon} {deptLabel}
              </h2>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 14 }}>
                {people.map(c => {
                  const role = c[`role_${lang}`] || c.role_en || c.role_cs;
                  return (
                    <div key={c.id} style={{ background: '#f9fafb', borderRadius: 10, padding: '16px', border: '1px solid #f3f4f6' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                        <div style={{ width: 42, height: 42, borderRadius: '50%', background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 15, fontWeight: 700, flexShrink: 0 }}>
                          {c.name.split(' ').map(n => n[0]).slice(0, 2).join('')}
                        </div>
                        <div>
                          <div style={{ fontWeight: 700, fontSize: 15, color: '#111827' }}>{c.name}</div>
                          {role && <div style={{ fontSize: 12, color: '#9ca3af' }}>{role}</div>}
                        </div>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                        {c.email && <a href={`mailto:${c.email}`} style={{ fontSize: 13, color: '#0e76bc', textDecoration: 'none' }}>✉️ {c.email}</a>}
                        {c.phone && <a href={`tel:${c.phone}`} style={{ fontSize: 13, color: '#374151', textDecoration: 'none' }}>📞 {c.phone}</a>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        {contacts.length === 0 && (
          <div style={{ textAlign: 'center', padding: 40, color: '#9ca3af', background: '#fff', borderRadius: 12, border: '1px solid #f3f4f6' }}>
            Žádné kontakty. Přidejte je v admin panelu.
          </div>
        )}
      </div>
    </div>
  );
}
